// Portal shell / nav icons — Ionicons v7 outline, same one-export-per-icon
// convention as ./index.tsx (tree-shaken inline SVG, never the bundle).
import type { SVGProps } from 'react';

const S = {
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 32,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
} as const;

export function GridIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 512 512" {...S} {...props}>
      <rect x="48" y="48" width="176" height="176" rx="20" />
      <rect x="288" y="48" width="176" height="176" rx="20" />
      <rect x="48" y="288" width="176" height="176" rx="20" />
      <rect x="288" y="288" width="176" height="176" rx="20" />
    </svg>
  );
}
export function QrIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 512 512" {...S} {...props}>
      <rect x="336" y="336" width="80" height="80" rx="8" />
      <rect x="272" y="272" width="64" height="64" rx="8" />
      <rect x="416" y="416" width="64" height="64" rx="8" />
      <rect x="432" y="272" width="48" height="48" rx="8" />
      <rect x="272" y="432" width="48" height="48" rx="8" />
      <rect x="336" y="96" width="80" height="80" rx="8" />
      <rect x="288" y="48" width="176" height="176" rx="16" />
      <rect x="96" y="96" width="80" height="80" rx="8" />
      <rect x="48" y="48" width="176" height="176" rx="16" />
      <rect x="96" y="336" width="80" height="80" rx="8" />
      <rect x="48" y="288" width="176" height="176" rx="16" />
    </svg>
  );
}
export function ListIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 512 512" {...S} {...props}>
      <path d="M160 144h288M160 256h288M160 368h288" strokeWidth={40} />
      <circle cx="80" cy="144" r="16" fill="currentColor" stroke="none" />
      <circle cx="80" cy="256" r="16" fill="currentColor" stroke="none" />
      <circle cx="80" cy="368" r="16" fill="currentColor" stroke="none" />
    </svg>
  );
}
export function PricetagIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 512 512" {...S} {...props}>
      <path d="M435.25 48h-122.9a14.46 14.46 0 0 0-10.2 4.2L56.45 297.9a28.85 28.85 0 0 0 0 40.7l117 117a28.86 28.86 0 0 0 40.7 0L459.75 210a14.46 14.46 0 0 0 4.2-10.2v-123a28.66 28.66 0 0 0-28.7-28.8z" />
      <path d="M384 160a32 32 0 1 1-32-32 32 32 0 0 1 32 32z" />
    </svg>
  );
}
export function BusinessIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 512 512" {...S} {...props}>
      <path d="M176 416v64M80 32h192a32 32 0 0 1 32 32v412a4 4 0 0 1-4 4H48V64a32 32 0 0 1 32-32z" />
      <path d="M320 192h112a32 32 0 0 1 32 32v256H320V192z" />
      <path d="M112 112h32M112 192h32M112 272h32M112 352h32M192 112h32M192 192h32M192 272h32M192 352h32M368 272h32M368 352h32" />
    </svg>
  );
}
export function WalletIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 512 512" {...S} {...props}>
      <path d="M95.5 104h320a87.73 87.73 0 0 1 11.18.71 66 66 0 0 0-77.51-55.56L86 94.08a66 66 0 0 0-41.07 26.13A87.57 87.57 0 0 1 95.5 104z" />
      <path d="M415.5 128h-320a64.07 64.07 0 0 0-64 64v192a64.07 64.07 0 0 0 64 64h320a64.07 64.07 0 0 0 64-64V192a64.07 64.07 0 0 0-64-64zM368 320a32 32 0 1 1 32-32 32 32 0 0 1-32 32z" />
    </svg>
  );
}
export function DocumentIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 512 512" {...S} {...props}>
      <path d="M416 221.25V416a48 48 0 0 1-48 48H144a48 48 0 0 1-48-48V96a48 48 0 0 1 48-48h98.75a32 32 0 0 1 22.62 9.37l141.26 141.26a32 32 0 0 1 9.37 22.62z" />
      <path d="M256 56v120a32 32 0 0 0 32 32h120M176 288h160M176 368h160" />
    </svg>
  );
}
export function StarIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 512 512" {...S} {...props}>
      <path d="M480 208H308L256 48l-52 160H32l140 96-54 160 138-100 138 100-54-160z" />
    </svg>
  );
}
export function ShieldIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 512 512" {...S} {...props}>
      <path d="M463.1 112.37C373.68 96.33 336.71 84.45 256 48c-80.71 36.45-117.68 48.33-207.1 64.37C32.7 369.13 240.58 457.79 256 464c15.42-6.21 223.3-94.87 207.1-351.63z" />
      <path d="m338 176-96 160-64-64" />
    </svg>
  );
}
export function PeopleIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 512 512" {...S} {...props}>
      <path d="M402 168c-2.93 40.67-33.1 72-66 72s-63.12-31.32-66-72c-3-42.31 26.37-72 66-72s69 30.46 66 72z" />
      <path d="M336 304c-65.17 0-127.84 32.37-143.54 95.41-2.08 8.34 3.15 16.59 11.72 16.59h263.65c8.57 0 13.77-8.25 11.72-16.59C463.85 335.36 401.18 304 336 304z" />
      <path d="M200 185.94c-2.34 32.48-26.72 58.06-53 58.06s-50.7-25.57-53-58.06C91.61 152.15 115.34 128 147 128s55.39 24.77 53 57.94z" />
      <path d="M206 306c-18.05-8.27-37.93-11.45-59-11.45-52 0-102.1 25.85-114.65 76.2-1.65 6.66 2.53 13.25 9.37 13.25H154" />
    </svg>
  );
}
export function RestaurantIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 512 512" {...S} {...props}>
      <path d="M57.49 47.74 310.1 262.5l-69.21 69.21-92.88-92.88a74.86 74.86 0 0 1-21.2-55.17 71.33 71.33 0 0 1 2.67-18.49m195.91 61.86 115.3-115.3M400 80l-73 73M416 128l-73 73" />
      <path d="M352 276.08 476.74 400.8a16 16 0 0 1 0 22.63l-37.3 37.31a16 16 0 0 1-22.63 0L291.96 336.33M114.68 358.03l-62.4 62.4a16 16 0 0 0 0 22.63l37.3 37.3a16 16 0 0 0 22.63 0l74.98-74.98" />
    </svg>
  );
}
export function PulseIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 512 512" {...S} {...props}>
      <path d="M48 320h64l64-256 64 384 64-224 32 96h64" />
      <circle cx="432" cy="320" r="32" />
    </svg>
  );
}
export function MegaphoneIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 512 512" {...S} {...props}>
      <path d="M407.94 52.22S321.3 160 240 160H80a16 16 0 0 0-16 16v96a16 16 0 0 0 16 16h160c81.3 0 167.94 108.23 167.94 108.23 6.06 8 24.06 2.52 24.06-9.83V62c0-12.31-17-18.82-24.06-9.78zM64 256s-16-6-16-32 16-32 16-32M448 246s16-4.33 16-22-16-22-16-22M256 160v128M112 160v128" />
      <path d="M144 288v168a8 8 0 0 0 8 8h53a16 16 0 0 0 15.29-20.73C211.91 416.39 192 386.08 192 336h16a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16h-64" />
    </svg>
  );
}
export function CashIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 512 512" {...S} {...props}>
      <rect x="32" y="80" width="448" height="256" rx="16" />
      <path d="M64 384h384M96 432h320" />
      <circle cx="256" cy="208" r="80" />
      <path d="M480 160a80 80 0 0 1-80-80M32 160a80 80 0 0 0 80-80M480 256a80 80 0 0 0-80 80M32 256a80 80 0 0 1 80 80" />
    </svg>
  );
}
export function BuildIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 512 512" {...S} {...props}>
      <path d="M457.05 118.08a79.83 79.83 0 0 1-110 112.73L153.42 424.42a48 48 0 0 1-67.84-67.84l193.61-193.61a79.83 79.83 0 0 1 112.73-110l-50.3 50.3 61.72 61.72z" />
    </svg>
  );
}
export function MenuIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 512 512" {...S} strokeWidth={40} {...props}>
      <path d="M88 152h336M88 256h336M88 360h336" />
    </svg>
  );
}
export function CloseIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 512 512" {...S} strokeWidth={40} {...props}>
      <path d="M368 368 144 144M368 144 144 368" />
    </svg>
  );
}
export function LogOutIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 512 512" {...S} {...props}>
      <path d="M304 336v40a40 40 0 0 1-40 40H104a40 40 0 0 1-40-40V136a40 40 0 0 1 40-40h152c22.09 0 48 17.91 48 40v40M368 336l80-80-80-80M176 256h256" />
    </svg>
  );
}
export function ChevronDownIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 512 512" {...S} strokeWidth={48} {...props}>
      <path d="m112 184 144 144 144-144" />
    </svg>
  );
}
export function RefreshIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 512 512" {...S} {...props}>
      <path d="M320 146s24.36-12-64-12a160 160 0 1 0 160 160" />
      <path d="m256 58 80 80-80 80" />
    </svg>
  );
}
export function LocationIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 512 512" {...S} {...props}>
      <path d="M256 48c-79.5 0-144 61.39-144 137 0 87 96 224.87 131.25 272.49a15.77 15.77 0 0 0 25.5 0C304 409.89 400 272.07 400 185c0-75.61-64.5-137-144-137z" />
      <circle cx="256" cy="192" r="48" />
    </svg>
  );
}
export function SunnyIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 512 512" {...S} {...props}>
      <path d="M256 48v48M256 416v48M403.08 108.92l-33.94 33.94M142.86 369.14l-33.94 33.94M464 256h-48M96 256H48M403.08 403.08l-33.94-33.94M142.86 142.86l-33.94-33.94" />
      <circle cx="256" cy="256" r="80" />
    </svg>
  );
}
export function MoonIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 512 512" {...S} {...props}>
      <path d="M160 136c0-30.62 4.51-61.61 16-88C99.57 81.27 48 159.32 48 248c0 119.29 96.71 216 216 216 88.68 0 166.73-51.57 200-128-26.39 11.49-57.38 16-88 16-119.29 0-216-96.71-216-216z" />
    </svg>
  );
}
